import React from 'react';
import Breadcrumb from './Breadcrumb';

const GameLayout = ({ children, breadcrumbItems }) => {
  return (
    <div className="flex flex-col h-full">
      <Breadcrumb items={breadcrumbItems} />
      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-2xl p-4">
          {children}
        </div>
      </div>
    </div>
  );
};

export default GameLayout; 